import React from 'react';

const SearchTerm = (props) => {

    const updateTerm = () => {
        if(props.searchTerm) {
            props.handleSetTerm(props.searchTerm);
        }
    };

    return <span className="search-suggestions__item search-suggestions__item--term" onClick={updateTerm}>{props.children}</span>
}

const PopularSearches = ( props ) => {

    return (
        <>
            <p className="search-overlay-heading">See our <span className="search-overlay-heading__highlight">popular searches</span> below&hellip;</p>

            <div className="container">
                <div className="search-suggestions">
                    <span className="search-suggestions__item search-suggestions__item--label">Popular Searches:</span>
                    <SearchTerm searchTerm="Lunch with" {...props}>Lunch with...</SearchTerm>
                    <SearchTerm searchTerm="Lewis Hamilton" {...props}>Lewis Hamilton</SearchTerm>
                    <SearchTerm searchTerm="Lotus" {...props}>Lotus</SearchTerm>
                    <SearchTerm searchTerm="Porsche" {...props}>Porsche</SearchTerm>
                    <SearchTerm searchTerm="Jim Clark" {...props}>Jim Clark</SearchTerm>
                </div>
            </div>

        </>
    )

}

export default PopularSearches;